"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
function TextTd(props) {
    var _a;
    var _b = props.cell, value = _b.value, rowSpan = _b.rowSpan, text = _b.text;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ colSpan: props.cell.colSpan, style: props.style, rowSpan: rowSpan, className: index_modules_css_1.default.textCell }, { children: (_a = text !== null && text !== void 0 ? text : value) !== null && _a !== void 0 ? _a : '' })));
}
exports.TextTd = TextTd;
